import { ViewportScroller } from '@angular/common';
import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[miFocusOnTab]',
    standalone: true
})
export class FocusOnTabDirective implements AfterViewInit {
    constructor(private el: ElementRef, private viewportScroller: ViewportScroller) { }

    ngAfterViewInit(): void {
        // גלילה לראש הדף
        this.viewportScroller.scrollToPosition([0, 0]);
    }
}